export default function getInitState() {
    return {
        licenceManagementFields: [
            {
                name: "id",
                label: "ID",
                formVisible: false
            },
            {
                name: "expirationDate",
                label: "Lejárati idő",
                formType: 'date',
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "trialExpirationDate",
                label: "Próbaverzió lejárati idő",
                formType: 'date',
                formSize: 2,
                formRequired: true,
                formVisible: true
            },
            {
                name: "justWarning",
                label: "Csak figyelmeztetés",
                formType: 'checkbox',
                formSize: 2,
                formVisible: true
            },
            {
                name: "blockLogin",
                label: "Bejelentkezés blokkolása",
                formType: 'checkbox',
                formSize: 2,
                formVisible: true
            }
        ]
    }
}
